"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("./index.styled");
var _jsxRuntime = require("react/jsx-runtime");
const Align = function (_ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Align, {
    ...props,
    "data-testid": "Align",
    children: children
  });
};
var _default = exports.default = Align;